import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Mounted on the My Team page. Reloads the page when the shared
// date-navigation reports a date change so the team rows reflect the
// new selected date. Navigates to `data-team-date-sync-base-url-value`
// (typically "/my-team", *without* any current ?date= URL override)
// so the controller falls back to the freshly-saved user.selected_date.
export default class extends Controller {
  static values = { baseUrl: { type: String, default: "/my-team" } }

  refresh() {
    Turbo.visit(this.baseUrlValue, { action: "replace" })
  }

  // Click on a sparkline bar (or its day label). Navigates via URL
  // override so user.selected_date isn't touched — this is a transient
  // "show me this day" gesture, not a persistent date pin.
  selectDay(event) {
    const date = event.params.date
    if (!date) return
    Turbo.visit(`${this.baseUrlValue}?date=${date}`, { action: "replace" })
  }
}
